import { useContext, useMemo } from 'react';

import { LoadingButton } from '@zg-rentals/loading-components';

import { RMWContext } from '../../providers/RMWContext';
import { DashboardContext } from '../../containers/DashboardPage/context';
import { LoadingMapContext } from '../../providers/LoadingMapContext/context';

import { useSelector } from '../../selectors/useSelector';

import { VERTICAL_DISPLAY_TYPE } from '../../constants/PropertiesConstants';

import { RMW_PATH } from '../../pathsManifest';

import ConnectedInquiries from '../ConnectedInquiries';

import ConnectedModuleCard from '../../components/ConnectedModuleCard';

import { StyledNoUnderlineAnchor } from '../../StyledComponents/StyledComponents';

import type { State as DashboardState } from '../../containers/DashboardPage/reducer';

const InquiriesModule = () => {
  const { dashboardState } = useContext(DashboardContext);
  const { paths } = useContext(RMWContext);
  const {
    loadingByComponent: { ConnectedInquiries: isConnectedInquiriesLoading },
  } = useContext(LoadingMapContext);

  const listingAlias = useSelector((state) => state.properties.currentProperty.listingAlias);

  const { activePath }: Partial<DashboardState> = dashboardState;
  const inquiriesPath = `${paths.base}/inbox/${listingAlias}?byProperty=true`;
  const isActivePathOverview = activePath === RMW_PATH.DASHBOARD_OVERVIEW;

  const renderCTA = useMemo(() => {
    const ctaLabel = 'View in messages';

    return (
      <>
        {isActivePathOverview ? (
          <StyledNoUnderlineAnchor href={inquiriesPath} target="_self">
            {ctaLabel}
          </StyledNoUnderlineAnchor>
        ) : (
          <LoadingButton
            tone="neutral"
            emphasis="outlined"
            size="sm"
            data-testid="view-all-applications-cta"
            isLoading={isConnectedInquiriesLoading}
            loadingWidth="10vw"
            asChild={true}
          >
            <a href={inquiriesPath} target="_self">
              {ctaLabel}
            </a>
          </LoadingButton>
        )}
      </>
    );
  }, [isActivePathOverview, isConnectedInquiriesLoading, inquiriesPath]);

  return (
    <ConnectedModuleCard
      data-testid="InquiriesModule"
      title="Inquiries"
      ctaComponent={renderCTA}
      ctaFontColor="text.subtle"
      ctaFontType="body-sm"
      justifyHeadingContent={'center'}
      isLoading={false}
    >
      <ConnectedInquiries displayType={VERTICAL_DISPLAY_TYPE.SIMPLE} updateMinModuleHeight={() => 0} />
    </ConnectedModuleCard>
  );
};

export default InquiriesModule;
